import React, { useEffect, useState } from "react";
import AllProdi from "./components/AllProdi";
import AudioPlayer from "./components/AudioPlayer";
import ComingSoon from "./components/ComingSoon";
import Daftar from "./components/Daftar";
import Hero from "./components/Hero";
import JalurPenerimaan from "./components/JalurPenerimaan";
import Layout from "./components/Layout";
import Nilai from "./components/Nilai";
import PilihanProdi from "./components/PilihanProdi";
import Sejarah from "./components/Sejarah";
import TanggalSeleksi from "./components/TanggalSeleksi";
import Testimoni from "./components/Testimoni";

function App() {
  const [staticData, setStaticData] = useState();

  const getStaticData = async () => {
    const res = await fetch("./static-data.json");
    const data = await res.json();
    setStaticData(data);
    console.log(data);
  };

  useEffect(() => {
    getStaticData();
  }, []);

  if (!staticData) return null;

  return (
    <Layout>
      <AudioPlayer />
      <Hero data={staticData.hero} />
      <Sejarah data={staticData.sejarah} />
      <Nilai data={staticData.nilai} />
      <TanggalSeleksi data={staticData.tanggal_seleksi} />
      <JalurPenerimaan data={staticData.jalur_penerimaan} />
      <PilihanProdi data={staticData.pilihan_prodi} />
      <AllProdi data={staticData.all_prodi} />
      <Testimoni data={staticData.testimoni} />
      <ComingSoon data={staticData.coming_soon} />
      <Daftar data={staticData.daftar} closing={staticData.footer} />
    </Layout>
  );
}

export default App;
